import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawers } from 'app/types/drawer';
import { FieldProps, DataForm, FieldType, FileType } from 'components';
import { ToolTest } from 'app/types/tool';
import moment from 'moment';
import { formats } from 'utils/datetime';
import { normalizeFile } from 'utils/file';

type ToolTestFormProps = {
  handleSubmit: (values: any) => void;
  meta: any;
  toolTest?: ToolTest;
  redirectTo?: string;
}

const ToolTestForm = ({ toolTest, handleSubmit, meta, redirectTo }: ToolTestFormProps) => {
  const { t } = useTranslation();
  const [ isSuccessful, setIsSuccessful ] = useState<boolean | undefined>(toolTest?.IsSuccessful);

  const fields: FieldProps[] = [
    {
      name: 'ExecutedAt',
      label: t('entities.tooltest.executedat'),
      type: FieldType.DATE,
      datePicker: { dateFormat: formats.DD_MM_YYYY },
      required: true
    },
    {
      name: 'IsSuccessful',
      label: t('entities.tooltest.issuccessful'),
      type: FieldType.SELECT,
      required: true,
      selectProps: {
        options: [
          { label: t('entities.tooltest.result.success'), value: true },
          { label: t('entities.tooltest.result.failure'), value: false },
        ],
        labelKey: 'label',
        valueKey: 'value',
        allowClear: false,
        showSearch: false
      },
      onChange: (value: boolean) => setIsSuccessful(value),
      setFields: {
        keys: [ 'ValidTo' ],
        onSelect: () => ({ ValidTo: undefined })
      }
    },
    ...(isSuccessful ? [ {
      name: 'ValidTo',
      label: t('entities.tooltest.validto'),
      type: FieldType.DATE,
      datePicker: { dateFormat: formats.DD_MM_YYYY }
    } ] : []),
    {
      name: 'Comment',
      label: t('entities.tooltest.comment'),
      type: FieldType.TEXTAREA,
      max: 1024
    },
    {
      name: 'ExecutorName',
      label: t('entities.tooltest.executorname'),
      type: FieldType.TEXT,
      required: true,
      max: 256
    },
    {
      name: 'CompanyName',
      label: t('entities.tooltest.companyname'),
      type: FieldType.TEXT,
      max: 512
    },
    {
      name: 'ReportFile',
      label: t('entities.tooltest.reportfile'),
      type: FieldType.FILE,
      allowedFileType: FileType.PDF,
    }
  ];


  const initialValues = toolTest ? {
    ...toolTest,
    ExecutedAt: toolTest.ExecutedAt ? moment(toolTest.ExecutedAt) : undefined,
    ValidTo: toolTest.ValidTo ? moment(toolTest.ValidTo) : undefined,
    ReportFile: normalizeFile(toolTest.ReportFileName ?? 'Report', toolTest.ReportUrl)
  } : { ExecutedAt: moment() };

  return (
    <DataForm
      id={toolTest ? Drawers.EDIT_TOOL_TEST : Drawers.ADD_TOOL_TEST}
      entity="tooltest"
      onSubmit={handleSubmit}
      fields={fields}
      meta={meta}
      redirectTo={redirectTo}
      initialValues={initialValues}
    />
  );
};

export default ToolTestForm;
